export const HIT_TOLERANCE = 10; // px – Tolerance (radius) used for finding hits on features via pointer positions
